import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const basketGreyBackgroundSelector = createSelector(testTargetOffersSelector, offers => offers.basketGreyBackground || Empty.Object);

export { basketGreyBackgroundSelector };
